module.exports = "#field_appointmentTime select {\n  padding: 0.375rem 0.5rem; }\n\n#field_appointmentTimeMin {\n  padding: 0.375rem 0.3rem; }\n\n#field_appointmentMeridian {\n  padding: 0.375rem 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/appointment/appointment.component.scss
// module id = ./src/app/appointment/appointment.component.scss
// module chunks = main